import React, { Component } from "react";
import { Col, Row } from "antd";
import InputForm from "./InputForm";
import axios from "axios";


class MunicipioFrame extends Component {
    state = {
        UFSelect: [],
        municipioSelect: [],
        cmun_uf: {
            key: '0',
            label: '',
        },
        codigo: {
            key: '0',
            label: '',
        },
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                cmun_uf: {
                    key: String(this.props.value.cmun_uf),
                    labbel: ''
                },
                codigo: {
                    key: this.props.value.key,
                    label: '',
                },
            }, () => {
                if (this.props.value.key) {
                    this.buscaMunicipio(this.props.value.cmun_uf);
                }
            });
        }
    }

    componentDidMount() {
        this.buscaUF();
    }

    buscaUF = (value) => {
        this.setState({ UFSelect: [] })
        axios.get('/cepsUF/lista', {
        }).then(response => {
            const { data } = response;
            const UFSelect = data.map(regList => {
                return {
                    key: regList.cuf_codigo,
                    label: regList.cuf_sigla
                }
            });
            this.setState({ UFSelect })
        }).catch(error => {
            console.error(error.response);
        })
    }

    buscaMunicipio = (value) => {
        this.setState({ municipioSelect: [] })
        if (value) {
            axios.get('/cepsMunicipio/lista', {
                params: {
                    uf: value
                }
            }).then(response => {
                const { data } = response;
                const municipioSelect = data.map(regList => {
                    return {
                        key: regList.cmun_codigo,
                        label: regList.cmun_codigo + ' - ' + regList.cmun_descricao,
                        cmun_uf: regList.cmun_uf,
                        cuf_sigla: regList.cuf_sigla,
                    }
                });
                if ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) {
                    municipioSelect.unshift({ key: '0', label: this.props.descricaoPrimeiroItem });
                }
                this.setState({ municipioSelect })
            }).catch(error => {
                console.error(error.response);
            })
        }
    }



    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({ [id]: value });
        const state = {};
        const iInd = this.state.municipioSelect.findIndex(registro => String(registro.key) === String(value.key));
        state[id] = {
            key: value.key,
            label: value.label,
            cmun_uf: this.state.municipioSelect[iInd].cmun_uf,
            cuf_sigla: this.state.municipioSelect[iInd].cuf_sigla,
        };
        this.props.onChange(state);
    };

    onChangeUF = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({ [id]: value });
        this.buscaMunicipio(value.key);
    };



    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo, cmun_uf, UFSelect, municipioSelect } = this.state;

        // console.log('MunicipioFrame state: ', this.state);
        // console.log('MunicipioFrame props: ', this.props);

        return (
            <div>
                <Col xs={6} style={{}}>
                    <span>UF</span>
                    <InputForm
                        type="select"
                        id="cmun_uf"
                        ref="cmun_uf"
                        value={cmun_uf}
                        placeholder="UF"
                        onChange={this.onChangeUF}
                        data={UFSelect}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                        disabled={disabled ? true : false}
                        showSearch
                    />
                </Col>
                <Col xs={18} style={{}}>
                    <span>Município</span>
                    <InputForm
                        type="select"
                        id={id}
                        ref={id}
                        value={codigo}
                        onChange={this.onChange}
                        data={municipioSelect}
                        validator={value => Boolean(value)}
                        style={{ width: width }}
                        disabled={disabled ? true : false}
                        showSearch
                    />
                </Col>
            </div>
        );
    }
}

export default MunicipioFrame;



// WEBPACK FOOTER //
// ./src/components/MunicipioFrame.js